import type { App as InstanceVueType } from 'vue';
import type { Locale } from '@aplus-frontend/antdv/es/locale';
import { useLocalStorage } from '@vueuse/core';
import { LocaleTypeName, type LocaleType } from './interface';
import { createI18n } from 'vue-i18n';
import enUSMessages from './lang/en_US/index';
import zhCNMessages from './lang/zh_CN/index';

export const LOCALE_KEY = 'boat-i18n-locale';
const _locale = useLocalStorage<LocaleType>(LOCALE_KEY, 'zh_CN');

const _i18n = createI18n({
  legacy: false,
  fallbackLocale: 'zh_CN',

  availableLocales: ['zh_CN', 'en_US'],
  sync: true, //If you don’t want to inherit locale from global scope, you need to set sync of i18n component option to false.
  silentTranslationWarn: true, // true - warning off
  missingWarn: false,
  silentFallbackWarn: true,
  locale: _locale.value,
  messages: {
    en_US: enUSMessages,
    zh_CN: zhCNMessages
  }
});

export const getI18n = () => {
  return _i18n;
};

export const getLocale = () => {
  return _locale.value;
};

export const setLocale = (locale: LocaleType) => {
  if (!LocaleTypeName[locale]) {
    locale = 'zh_CN';
  }
  if (locale === _locale.value) {
    return;
  }
  _locale.value = locale;
  _i18n.global.locale.value = locale;
  window.location.reload();
};

export const getAntLocale = () => {
  return (
    _i18n.global.getLocaleMessage<{
      antdLocale: Locale;
    }>(_locale.value)?.antdLocale ?? {}
  );
};

export const useI18n = () => {
  return {
    t: _i18n.global.t
  };
};

export const setupI18n = (app: InstanceVueType) => {
  app.use(_i18n);
};

export * from './interface';
